var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.CountySelectFeature = new Class({
    Implements: [Options, Events],
    options: {
        dataset: 'org.mesonet.okfirst.shapes',
        selectable_limit: 1,
        selected_id: []
    },
    layer: null,
    range_layer: null,
    select_obj: null,
    mouse_move_obj: null,
    bound_methods: {},
    ready: false,
    features: [],
    initialize: function (options) {
        this.setOptions(options);
        this.bound_methods.on_selection = this.on_selection.bind(this);
        this.layer = new OCS.Viewer.Classes.DefaultLayer({'style_type': 'county'});
        this.layer.create();

        var gm = OCS.Viewer.Functions.get_geometry_manager();

        this.mouse_move_obj = this.layer.add_select_feature_mousemove();
        this.select_obj = this.layer.add_select_feature_click({selectable_limit: this.options.selectable_limit});
        // Grab the county data and turn on the selected features we already know about in the db.
        var variables = [];
        Object.keys(OCS.Viewer.Config.watched_county_objs).each(function (zone) {
            var feature = OCS.Geometry.Functions.getGeometryBySid(zone, OCS.Viewer.Config.default_projection, OCS.Viewer.Config.default_geog_simplification);
            if(feature) {
                this.process_feature({type: "Feature", geometry: feature.get_geometry(), crs: feature.options.crs, id: feature.options.properties.sid});
            } else {
                variables.combine([zone]);
            }

        }.bind(this));
        var source = this.layer.create_geoJSON_source({
            ready_callback: this.on_source_ready.bind(this)
        });
        this.layer.set_source(source);
        if (variables.length) {
            var gm_req = gm.request({method: "geometries", "ids": variables, "projection": OCS.Viewer.Config.default_projection, "simplify": OCS.Viewer.Config.default_geog_simplification, max_ids_to_request: variables.length});
            if(gm_req.then) {
                // We got back a promise
                gm_req.addEvent('complete', function(res) {
                    if(res && res.result && res.result.length) {
                        res.result.each(function(f) {
                            this.process_feature({type: "Feature", geometry: f.get_geometry(), crs: f.options.crs, id: f.options.properties.sid});
                        }, this);
                        source.addFeatures(this.features);

                    }
                }.bind(this));
                gm_req.start();
            }
        } else {
            source.addFeatures(this.features);
        }

    },
    process_feature: function(feature) {
        var format = new ol.format.GeoJSON();
        var dataProjection = OCS.Viewer.Config.default_display_projection;
        if(feature.crs) {
            dataProjection = feature.crs.properties.name;
            delete feature.crs;
        }

        var ol_feature = format.readFeature(feature, {"dataProjection": dataProjection, "featureProjection": OCS.Viewer.Config.default_projection});
        if(feature.id) {
            ol_feature.setId(feature.id);
        }
        this.features.push(ol_feature);

    },
    on_source_ready: function () {
        var source = this.layer.get_source();
        var selected_features = this.select_obj.getFeatures();
        Object.each(this.options.selected_id, function (ww_county, idx) {
            if (!ww_county) {
                return;
            }
            var county_obj = this.translate_id_to_county_obj(ww_county);
            if (county_obj) {
                var feature = source.getFeatureById(county_obj.CID.toUpperCase());
                if(feature) {
                    feature.set('selected', true);
                    if (this.options.debug) {
                        console.log('map_manager ' + this.map_selector + ': found feature! ' + ww_county);
                    }
                    selected_features.push(feature);
                }
            }
        }.bind(this));   
        this.select_obj.on('select', this.bound_methods.on_selection);
    },
    on_selection: function (event) {
        var selected_features = this.select_obj.getFeatures();
        var county_obj;
        
        if (selected_features.getLength() > this.options.selectable_limit) {
            if (this.options.debug) {
                console.log('map_manager ' + this.map_selector + ': To many features being selected removing the last one.');
            }
            var feature = selected_features.pop();
            feature.set('selected', false);
            return;
        }
        
        var features = [];
        selected_features.forEach(function(feature) {
            county_obj = this.translate_id_to_county_obj(feature.getId());
            features.push(county_obj.ID);
        }.bind(this));
        this.options.selected_id = features;        
        this.fireEvent('selected', {selected: this.options.selected_id});

        // Add to db if not contained already in it
    },

    translate_id_to_county_obj: function (id) {
        var county_obj;
        var id_upper = id.toUpperCase();
        if (!OCS.Viewer.Config.watched_county_objs[id_upper]) {
            id_upper = OCS.Viewer.Functions.get_utilities().object_has_object_with_cond(OCS.Viewer.Config.watched_county_objs, function (value, key) {
                if (id_upper === value.CID || id_upper === value.ID) {
                    return true;
                }
                return false;
            });
        }
        county_obj = OCS.Viewer.Config.watched_county_objs[id_upper];
        return county_obj;
    },
    destroy: function () {
        this.removeEvents();
    }

});